import { render } from "./TabSummary.vue?vue&type=template&id=14480986&scoped=true"
import script from "./TabSummary.vue?vue&type=script&lang=js"
export * from "./TabSummary.vue?vue&type=script&lang=js"

import "./TabSummary.vue?vue&type=style&index=0&id=14480986&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14480986"]])

export default __exports__